// extracted by mini-css-extract-plugin
export default {"title":"MMMQp","description":"zaWkm","appExclusive":"UeZtI"};